import { useLanguage as g, useLocaleText as h, useEnvironment as v } from "@ingeniorforeningen/figurine-core";
import b from "axios";
import { resolveUmbracoHostOutsideAppshell as $ } from "./testing.js";
import { resolveEnvOutsideAppshell as B } from "./testing.js";
const l = {
  dev: "tst.",
  ci: "tst.",
  tst: "tst.",
  uat: "prep.",
  prep: "prep.",
  prod: ""
}, u = {
  dev: "ci.",
  ci: "ci.",
  tst: "ci.",
  uat: "uat.",
  prep: "uat.",
  prod: ""
}, I = (e) => {
  const { variables: t } = v(), r = t.env || "ci";
  let s = "https://umbraco-api.ida.dk";
  return e && /https:\/\/umbraco(\-api)?\.(.+\.)?ida\.dk/.test(e) ? e : (r !== "prod" && (s = `https://umbraco-api.${r}.ida.dk`), `${s}${e || ""}`);
}, L = (e) => `${I(e)}`, x = (e) => {
  const t = h();
  return e ? `${t.image}: ${e}` : void 0;
}, y = (e, t, r, s) => {
  const i = L(e), o = {
    orientation: "auto",
    src: i,
    objectPosition: s ? `${s.left * 100}% ${s.top * 100}%` : "50% 50%"
  };
  let a;
  if (t && t.length > 0) {
    const c = { banner: "Banner", landscape: "Landskab", portrait: "Portræt" };
    if (a = t.find((n) => n.alias === c[r || "landscape"]), a) {
      const { coordinates: n, width: d, height: f } = a, p = [];
      n && p.push(`cc=${n.x1},${n.y1},${n.x2},${n.y2}`), d && p.push(`width=${a.width}`), f && p.push(`height=${a.height}`), p.length > 0 && (o.src = `${i}?${p.join("&")}`), r === "banner" || r === "landscape" ? o.landscape = o.src : r === "portrait" && (o.portrait = o.src);
    }
  }
  return o;
}, m = ([e], t, r) => {
  const { language: s } = g(), i = e.properties?.[`altText_${s}`], o = x(e.properties?.byline);
  return {
    ...y(e.url, e.crops, r, e.focalPoint),
    alt: i,
    title: e.name,
    byline: o,
    polymorphicProps: {
      fill: !0,
      priority: t
    }
  };
}, U = (e) => e?.properties?.image ? m(e.properties.image) : e?.properties?.metaImage ? m(e?.properties?.metaImage) : {}, w = (e, t) => {
  const r = {
    href: "",
    target: "_self",
    text: ""
    // This is the default value, but it's not required
  };
  return e ? Array.isArray(e) ? w(e?.[0]) : (e.itemType ? r.href = e.url : r.href = e.linkType === "External" || e.linkType === "Media" ? e.url : e.route?.path, r.text = e.title, r.target = e.target || "_self", e.icon && (r.icon = e.icon), t && r?.href && r.href !== "" && r.href.split("/")[r.href.split("/").length - 1].toLowerCase() === t.toLowerCase() && (r.isSelected = !0), r) : r;
}, D = (e) => {
  if (!e || !e?.trim())
    return "X";
  const t = e.trim().replace(/^ti-/i, ""), r = t.split("-").filter((i) => i.trim());
  return r.length === 0 ? t : r.map((i) => {
    if (!i)
      return "";
    let o = i.charAt(0).toUpperCase() + i.slice(1).toLowerCase();
    return o = o.replace(
      /(\d+)([A-Za-z]+)/g,
      (a, c, n) => c + n.toLowerCase()
    ), o;
  }).join("");
}, E = (e) => {
  switch (e) {
    case "Studerende":
      return "student";
    case "IDA Forsikring":
    default:
      return "insurance";
  }
}, S = (e) => e.includes("forsikring") || e.includes("insurance") ? "IDA Forsikring" : e === "MitIda" ? "MitIda" : "IDA.DK", F = (e) => e === "IDA Forsikring" ? "IdaForsikringLogo" : e === "MitIda" ? "MitIdaLogo" : "IdaLogo", H = async (e, t) => b.get(
  `${$()}/umbraco/delivery/api/v2/content/item/${e}?expand=properties[components[properties[component[properties[all]],choosenEmployee[properties[all]]]]],properties[relatedContentCards[properties[all]],image[properties[all]],components[properties[image[properties[all]],component[properties[all]]]]]`,
  {
    headers: {
      "Accept-Language": t || "da"
    }
  }
), O = (e, t) => {
  const r = { ...t };
  return r?.properties?.websiteMenu.items && (r.properties.websiteMenu.items = r.properties.websiteMenu.items.filter(
    (s) => !e.includes(s.content.id)
  )), r;
}, P = (e, t) => {
  if (!e)
    return e;
  let r = JSON.stringify(e);
  return r = r?.replace(
    /\[env-onprem\]/g,
    l[t] || l.prod
  )?.replace(
    /\[env-soa\]/g,
    u[t] || u.prod
  ), JSON.parse(r);
};
export {
  H as fetchUmbracoNode,
  O as removeWebsiteMenuFromData,
  P as replaceEnvLinks,
  B as resolveEnvOutsideAppshell,
  S as resolveHost,
  D as resolveIcon,
  m as resolveImage,
  w as resolveLink,
  U as resolveLinkedPageImage,
  F as resolveLogo,
  E as resolveTheme,
  $ as resolveUmbracoHostOutsideAppshell
};
